import { importProvidersFrom, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AppComponent } from './app.component';

// Core
import { CoreModule } from 'src/app/core/core.module';

// Modules
import { LoginModule } from './modules/login/login.module';
import { SignUpModule } from './modules/sign-up/sign-up.module';
import { ForgotPasswordModule } from './modules/forgot-password/forgot-password.module';
import { FileUploadModule } from 'src/app/modules/file-upload/file-upload.module';
import { AuthGuard } from './core/auth/auth.guard';
import { FaqModule } from './modules/faq/faq.module';
import { FooterPagesModule } from './modules/footer-pages/footer-pages.module';
import { CustomerInformationModule } from 'src/app/modules/customer-information/customer-information.module';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: '',
        loadChildren: () => import('src/app/modules/login/login.module').then((m) => LoginModule)
      },
      {
        path: 'sign-up',
        loadChildren:() => import('src/app/modules/sign-up/sign-up.module').then((m) => SignUpModule)
      },
      {
        path: 'forgot-password',
        loadChildren: () => import('src/app/modules/forgot-password/forgot-password.module').then((m) => ForgotPasswordModule)
      },
      {
        path: 'file-upload',
        loadChildren: () => import('src/app/modules/file-upload/file-upload.module').then((m) => FileUploadModule),
        canActivate:[AuthGuard]
      },
      {
        path: 'faq',  
        loadChildren: () => import('src/app/modules/faq/faq.module').then((m) => FaqModule),
      },
      {
        path: 'footer-pages',  
        loadChildren: () => import('src/app/modules/footer-pages/footer-pages.module').then((m) => FooterPagesModule),
      },
      {
        path: 'create-account',  
        loadChildren: () => import('src/app/modules/customer-information/customer-information.module').then((m) => CustomerInformationModule),
        canActivate:[AuthGuard]
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule { }
